var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowUpgradeHint
    ? _c("div", { staticClass: "login-end-hint" }, [
        _c(
          "div",
          { staticClass: "login-end-hint-content-image" },
          [_c("el-image", { attrs: { src: "/images/icon_upgrade.png" } })],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }